import React from 'react'
import { useState } from 'react'
import Modal from 'react-modal';
import axios from 'axios'
import { _serverUrl2 } from '../../../config';

export default function TaskImageLog({id}) {

    const [visible,setVisible] = useState(false)
    const [log,setLog] = useState([])

    const onClickResimLog = async () => {
        await axios.get(_serverUrl2+'/main/getImageInfo/'+id)
        .then((res)=>{
            if(res.data.status){
                setLog(res.data.rows)
                setVisible(true)
            } else {
        
            }
        })
        .catch((err)=>{
        
        })
    }

    return (
        <>
           <button className='blueBtn' style={{fontSize:'11px',width:'40px',position:'absolute',bottom:'5px',right:'5px'}} onClick={()=> onClickResimLog()} >Bilgi</button>
            <Modal
            isOpen={visible}
            contentLabel="resim bilgi"
            closeTimeoutMS={200}
            style={customStyles}
        >
        <div className="row">
            <div className='col-sm-12' style={{marginBottom:'10px'}} >
                <label>Fotoğraf Bilgileri</label>
            </div>
            <div className='col-sm-12' >
                <table className='table table-sm' >
                    <tbody>
                        {log.map((d,i)=>{
                            return  <tr key={i} >
                                        <td>{d.date}</td>
                                        <td>{d.isim_soyisim} Tarafından Çekildi</td>
                                    </tr>
                        })}
                    </tbody>
                </table>
            </div>
            <div className='col-sm-3' >
                <button className='redBtn' onClick={()=> setVisible(false)}>Kapat</button>
            </div>
        </div>

        </Modal>
        </>
    )
}

const customStyles = {
    content: {
        backdropFilter:'blur(10px)',
        backgroundColor:'rgba(255, 255, 255, 0.8)',
        top: '50%',                                                                                             
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width:'551px',
        boxShadow:'rgba(0, 0, 0, 0.24) 0px 3px 8px'
    },
    overlay: {
        backdropFilter:'blur(2px)',
        backgroundColor:'rgba(0, 0, 0, 0.10)',
    }
  };
